import { t } from 'i18next';
import { MessageSquarePlus, X } from 'lucide-react';

import { LeftSideBarType, useBuilderStateContext } from '../builder-hooks';

import { GenerateFlow } from './generate-flow';
import { useChatStore } from './useChatStore';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export const AiBuilderSidebar = () => {
  const [setLeftSidebar] = useBuilderStateContext((state) => [
    state.setLeftSidebar,
  ]);
  const flowId = useBuilderStateContext((state) => state.flowVersion.flowId);
  const { clearMessages, turnsInFlight } = useChatStore();
  // Read straight from the store so this header never mounts the whole turn
  // hook (its socket listeners included) a second time
  const isGenerating = turnsInFlight[flowId] === true;

  return (
    <div className="max-w-4xl mx-auto h-full flex flex-col">
      <div className="flex px-2 pb-2 w-full gap-2 text-lg font-semibold items-center">
        {t('AI Builder')}
        <div className="grow" />
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => clearMessages(flowId)}
              disabled={isGenerating}
              aria-label={t('New conversation')}
            >
              <MessageSquarePlus size={16} />
            </Button>
          </TooltipTrigger>
          <TooltipContent>{t('New conversation')}</TooltipContent>
        </Tooltip>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setLeftSidebar(LeftSideBarType.NONE)}
          aria-label={t('Close')}
        >
          <X size={16} />
        </Button>
      </div>

      <div className="bg-white shadow flex-1 overflow-auto">
        <GenerateFlow />
      </div>
    </div>
  );
};
